import { Theme } from "@/shared/themes/Theme.interface";
import { CssVarColorsWithFont } from "@/shared/themes/CssVarColors.interface";
import { setFontFamily } from "@/shared/utils";

export function mapThemeColorsAsCssVars({ colors, font }: Theme): CssVarColorsWithFont {
    setFontFamily(font); // side effect to set the font family in the document
    return {
        "--et-font": font || "Inter",
        "--et-colors-background": colors?.background || "",
        "--et-colors-border": colors?.border || "",
        "--et-colors-brand": colors?.brand || "",
        "--et-colors-card-background": colors?.cardBackground || "",
        "--et-colors-card-text": colors?.cardText || "",
        "--et-colors-text": colors?.text || "",
    };
}
